import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export var TableFooterRowContent = function () { return (React.createElement(React.Fragment, null,
    React.createElement(RampWithNameTransform, { rampName: "FooterCornerBase" }),
    React.createElement(RampWithNameTransform, { rampName: "FooterCellsMapperBase" }))); };
